import { SendEmailProps } from "@redotech/redo-model/email/send-email-props";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const sendEmailFromTemplate = {
  name: "sendEmailFromTemplate" as const,
  input: z.object({
    sendEmailProps: SendEmailProps,
    returnId: zExt.objectId().optional(),
    emailTemplateId: zExt.objectId().optional(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
